import React, { useState } from 'react';
import Modal from 'react-modal';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css'; // Make sure this import is correct based on your file structure
import api from './Api.js';

Modal.setAppElement('#root');

function AddManufacturer({ isOpen, onClose, onAdd }) {
    const [name, setName] = useState('');
    const [contactInfo, setContactInfo] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!name) {
            alert('Manufacturer name is required');
            return;
        }
        try {
            const response = await api.post('/api/add-manufacturer', { name, contactInfo });
            onAdd({ ManufacturerID: response.data.ManufacturerID, Name: name });
            setName('');
            setContactInfo('');
            onClose(); // Close the modal on success
            alert('Manufacturer added successfully!');
        } catch (error) {
            alert('Failed to add manufacturer');
            console.error(error);
        }
    };

    return (
        <Modal isOpen={isOpen} onRequestClose={onClose} className="m-auto  p-4">
            <div className="modal-content bg-white">
                <div className="modal-header d-flex gap-2 justify-content-between">
                    <h5 className="modal-title">Add New Manufacturer</h5>
                    <button type="button" className="btn btn-secondary" onClick={onClose}>
                        <span>&times;</span>
                    </button>
                </div>
                <form onSubmit={handleSubmit} className="form-horizontal">
                    <div className="modal-body">
                        <div className="form-group">
                            <label>Manufacturer Name:</label>
                            <input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} required />
                        </div>
                        <div className="form-group">
                            <label>Contact Info:</label>
                            <input type="text" className="form-control" value={contactInfo} onChange={e => setContactInfo(e.target.value)} />
                        </div>
                    </div>
                    <div className="modal-footer d-flex gap-2">
                        <button type="submit" className="btn btn-primary">Add Manufacturer</button>
                        <button type="button" className="btn btn-secondary" onClick={onClose}>Close</button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}

export default AddManufacturer;
